import { object, string } from 'yup';
import i18n from '@components/i18n';

export const validationSchema = object({
  firstName: string().required(i18n.t('validation:required')),
  lastName: string().required(i18n.t('validation:required')),
  email: string().email().required(i18n.t('validation:required')),
});
